/**
 * Base schema fields common across collections
 */
export const baseFields = {
  uid: { _value: '', _rule: 'this.size() > 0', _immutable: true },
  displayName: { _value: '', _rule: 'this.size() > 0' },
  createdAt: { _value: '', _immutable: true },
  updatedAt: '',
};

/**
 * Address schema structure
 */
export const addressSchema = {
  addressLine: '',
  landmark: '',
  city: { _value: '', _rule: 'this.size() > 0' },
  state: '',
  pincode: { _value: '', _rule: 'this.matches("^[0-9]{6}$")' },
  country: { _value: 'IN', _rule: 'this == "IN"' },
};

/**
 * Location schema structure
 */
export const locationSchema = {
  lat: { _value: 0, _rule: 'this >= -90 && this <= 90' },
  lng: { _value: 0, _rule: 'this >= -180 && this <= 180' },
  addressFormatted: { _value: '', _rule: 'this.size() > 0' },
  h3Index: { _value: '', _rule: 'this.size() > 0', _optional: true },
};

/**
 * Get current timestamp in ISO format
 */
export const getTimestamp = () => new Date().toISOString();

/**
 * Create base fields for any collection
 */
export const createBaseFields = (uid, displayName) => ({
  id: uid,
  uid,
  displayName,
  createdAt: getTimestamp(),
  updatedAt: getTimestamp(),
});
